import { Icon } from '@uag/react-core';
import { OnboardingRequestDetailModel } from '@uag/welcome-shared/src/api/models';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
type Props = {
    request: OnboardingRequestDetailModel;
};

export const RequesterInformations = ({ request }: Props) => {
    const { t } = useTranslation();
    const requesterName = request.companyOnboardingResponsible?.model.displayName;
    const requestDate = format(new Date(request.createdDate), 'dd.MM.yyyy');

    return (
        <div className="gap-base flex">
            <div className="gap-sm flex w-3/5 flex-col">
                <div className="text-base">{t('requester')}</div>
                <div className="gap-base border-border-disabled bg-background-disabled px-md py-base flex w-full items-center border border-solid">
                    <Icon className="text-icon-disabled-light" icon="person" />
                    <p className="text-base">{requesterName}</p>
                </div>
            </div>
            <div className="gap-sm flex w-3/5 flex-col">
                <div className="text-base">{t('requestDate')}</div>
                <div className="border-border-disabled bg-background-disabled px-md py-base flex w-full items-center border border-solid">
                    <p className="text-base">{requestDate}</p>
                </div>
            </div>
        </div>
    );
};
